import React from 'react'
import PropTypes from 'prop-types'
import OpalTile from '../../../opal/OpalTile'
import AdminPage from '../../admin/shared/AdminPage'
import FlexRow from '../../../molecules/FlexRow'
import PolicyLink from '../../../atoms/PolicyLink'
import PolicyNotAvailable from '../../../atoms/PolicyNotAvailable'

const adminDenaliInternal = 'admin_denali_internal'
const adminDenaliCatalog = 'admin_denali_catalog'
const all = [adminDenaliInternal, adminDenaliCatalog]

function DataHomeIndexView ({ root }) {
  return (
    <AdminPage>
      <FlexRow className='items-center justify-center' style={{ flexWrap: 'wrap' }}>
        <PolicyLink to={`${root}/integrator`} policy={adminDenaliInternal}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Integrator
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/ingestion`} policy={adminDenaliInternal}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Ingestion
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/analysis`} policy={adminDenaliInternal}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Analysis
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/alerts`} policy={adminDenaliInternal}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Alerts
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/orchestration`} policy={adminDenaliInternal}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Orchestration
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/catalog`} policy={adminDenaliCatalog}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Data Catalog
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/orion-system`} policy={adminDenaliInternal}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Orion System Integration
          </OpalTile>
        </PolicyLink>
        <PolicyNotAvailable policies={all} />
      </FlexRow>
    </AdminPage>
  )
}

DataHomeIndexView.propTypes = {
  root: PropTypes.any
}

export default DataHomeIndexView
